import React, { useState, useContext } from 'react';
import Panel from '../../../../components/Panel';
import FormInput from '../../../../components/FormInput';
import RoundedButton from '../../../../components/RoundedButton';
import AuthContext from '../../../../contexts/AuthContext';
import './AccountSettings.scss';
import useAPI from '../../../../hooks/useAPI';

export default function AccountSettings () {
    const {
        user,
        onUpdateUser
    } = useContext(AuthContext);
    const api = useAPI();

    const [firstName, setFirstName] = useState(user.first_name || '');
    const [lastName, setLastName] = useState(user.last_name || '');
    const [errors, setErrors] = useState({});
    const [saving, setSaving] = useState(false);

    const handleSave = () => {
        let _errors = {}

        if (!firstName) {
            _errors.first_name = 'First name required.';
        }

        if (!lastName) {
            _errors.last_name = 'Last name required.';
        }

        setErrors(_errors);
        if (Object.keys(_errors).length) {
            return;
        }

        setSaving(true);
        api.put('/account', {
            first_name: firstName,
            last_name: lastName
        }).then((r) => {
            return r.json();
        }).then((r) => {
            if (r.status === 'ok') {
                onUpdateUser({
                    ...user,
                    first_name: firstName,
                    last_name: lastName
                });
            } else {
                alert('Unable to save information. Try again later.');
            }
        }).catch((e) => alert(e))
            .then(() => setSaving(false));
    };

    return (
        <div className='account-settings'>
            <Panel
                title="Account Settings"
                headerStyle={{
                    borderBottomWidth: 1,
                    borderStyle: 'solid',
                    borderColor: '#E2E3E8',
                    paddingBottom: 20
                }}
                contentStyle={{
                    paddingTop: 20
                }}
            >
                <div className='account-settings--content'>
                    <div className='row'>
                        <div className='col-12 col-lg-6'>
                            <FormInput
                                label={'First Name'}
                                placeholder="Your First Name"
                                required
                                onChange={(e) => {
                                    setFirstName(e.target.value);
                                    setErrors({
                                        ...errors,
                                        first_name: ''
                                    });
                                }}
                                disabled={saving}
                                value={firstName}
                                error={errors.first_name}
                                maxLength="40"
                            />
                        </div>
                        <div className='col-12 col-lg-6'>
                            <FormInput
                                label={'Last Name'}
                                placeholder="Your Last Name"
                                required
                                onChange={(e) => {
                                    setLastName(e.target.value);
                                    setErrors({
                                        ...errors,
                                        last_name: ''
                                    });
                                }}
                                disabled={saving}
                                value={lastName}
                                error={errors.last_name}
                                maxLength="40"
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12 col-lg-6'>
                            <FormInput
                                label={'Email Address'}
                                value={user.email || ''}
                                disabled
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <RoundedButton
                                solid
                                onClick={handleSave}
                                busy={saving}
                            >Save Changes</RoundedButton>
                        </div>
                    </div>
                </div>
            </Panel>
        </div>
    );
};